import runAfterPageLoad from "./runAfterPageLoad";

export default function ticketChannels() {
  runAfterPageLoad(() => {
    $("#channel_kind").on("select2:select", typeChangeHandler);

    const type = $("#channel_kind :selected").val();
    showSpecifics(type);
  });

  function typeChangeHandler(event) {
    const type = $(event.target).find(":selected").val();
    showSpecifics(type);
  }

  function showSpecifics(type) {
    $(".ticket-channel-specifics").hide();
    $(`.ticket-channel-specifics__${type}`).show();
  }
}
